// extracted by mini-css-extract-plugin
export default {"cardLogo":"zRiiK7rzQ51MOauHZo48"};